import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';

const BackButton: React.FC<{ onClick?: () => void }> = ({ onClick }) => {
  const navigate = useNavigate();
  const handle =
    onClick ??
    (() => {
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate('/app/settings'); // fallback route
      }
    });

  return (
    <button
      onClick={handle}
      aria-label="Go back"
      className="fixed z-50 left-4 bg-white bg-opacity-80 hover:bg-opacity-100 p-2 rounded-full shadow"
      style={{ top: 'var(--safe-top)' }}
    >
      <ChevronLeftIcon className="w-5 h-5 text-gray-800" />
    </button>
  );
};

export default BackButton;
